import AIIcon from '@static/images/icons/ai.svg';

export const expertiseData = [
	{
		title: 'Development of AI Solutions',
		description:
			'We design and build AI systems using the latest technologies, such as Machine Learning, NLP, and neural networks.',
	},
	{
		title: 'Data Processing with AI',
		description:
			'We assist in analyzing large datasets and applying them to practical business solutions.',
	},
	{
		title: 'AI Innovations in IoT',
		description:
			'We develop smart devices and control systems for various industries, from manufacturing to agriculture.',
	},
];

export const BusinessTransformation = [
	{
		title: 'Process automation',
		icon: AIIcon,
	},
	{
		title: 'Predictive analytics',
		icon: AIIcon,
	},
	{
		title: 'Quality control',
		icon: AIIcon,
	},
	{
		title: 'Marketing optimization',
		icon: AIIcon,
	},
	{
		title: 'Customer service enhancement',
		icon: AIIcon,
	},
	{
		title: 'Decision-making support',
		icon: AIIcon,
	},
	{
		title: 'Workforce management',
		icon: AIIcon,
	},
	{
		title: 'Risk and compliance management',
		icon: AIIcon,
	},
];
